import React, { useState, useEffect, useContext, useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { Paper, Grid, Typography,Tooltip, IconButton, FormControlLabel, Switch, RadioGroup, Radio } from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import RefreshIcon from "@material-ui/icons/Refresh";
import MUIDataTable from "mui-datatables";
import axios from "axios";

import MeteringPointProtocolUploadDialog  from "./MeteringPointProtocolUploadDialog"

import ListOfChips from "./ListOFChips";
import AppContext from "../AppContext";
import localforage from 'localforage';

import { superSearch } from '@codewell/super-search';

export default function MeteringPoints(props) {
  const context = useContext(AppContext);
  const intl = useIntl();
  const [showProtocolUploadDialog, setShowProtocolUploadDialog] = useState(false);
  const toggleProtocolUploadDialog = () => {
    setShowProtocolUploadDialog(!showProtocolUploadDialog);
  }

  const [meteringPoints, setMeteringPoints] = useState([]);
  const [checked, setCheked] = useState(true);

  const {options, columns} = useMemo(() => {
    const currentSettings = JSON.parse(localStorage.getItem("MeteringPointsSettings") || "{}");
    const columns = getColumns(currentSettings);
    return {options: getOptions(currentSettings), columns };
  }, [checked, meteringPoints]);

  const uploadButton = () => (
    <div>
    <Tooltip placement="top" title={intl.formatMessage({id: "upload_deviations.upload_button_title"})} >
      <IconButton
        onClick={() => {
          toggleProtocolUploadDialog()
        }}>
        <CloudUploadIcon />
      </IconButton>

    </Tooltip>
    </div>
  );

  function getOptions(savedSettings) {
    return {
      downloadOptions: {
        filename: "Metering_points.csv",
        separator: ";",
      },
      filterType: "multiselect",
      selectableRows: "none",
      responsive: "scrollMaxHeigh",
      elevation: 0,
      rowsPerPageOptions: [10, 20, 50],
      viewColumns: true,
      textLabels: intl.messages["MUIDataTables.textLabels"],
      onRowClick: (rowData) => {
        props.history.push("meteringpoint/" + rowData[0]);
      },
      rowsPerPage: savedSettings.rowsPerPage || 10,
      page: savedSettings.page || 0,
      sortOrder: savedSettings.sortOrder,    
      onTableChange: (action, tableState) => {
        const current = JSON.parse(localStorage.getItem("MeteringPointsSettings") || "{}");
        let sortOrder = undefined;
        if (action === 'sort') {
          const sortColumn = tableState.columns.filter(c => c.sortDirection !== 'none');
          if (sortColumn.length === 1) {
            sortOrder = { name: sortColumn[0].name, direction: sortColumn[0].sortDirection }
          }
        }
        localStorage.setItem(
          "MeteringPointsSettings",
          JSON.stringify({
            page: tableState.page,
            rowsPerPage: tableState.rowsPerPage,
            filterList: tableState.filterList,
            sortOrder: sortOrder ? sortOrder : current.sortOrder,
            columns: tableState.columns,
            orfilter: current.orfilter
          })
        );
      },
      setTableProps: () => {return {size: 'small'}},
      customSearch: (searchText, row) => 
        superSearch({ignore: [" "]})(searchText.toLowerCase(), { ...row }).fullMatch,
        
        customFilterDialogFooter: () => {
          return (
            <Grid>
              <br/>
              <br/>
              <Typography color="textSecondary" >
                <FormattedMessage id="metering_point.filter_table_toggle_heading" />
              </Typography>      
              <Tooltip title={intl.formatMessage({ id: "metering_point.filter_table_toggle_tooltip" })}>
                <RadioGroup row>
                  <FormControlLabel 
                    control={
                      <Radio
                        color="primary"
                        checked={checked}
                        onChange={() => handleChange(true)}
                      />
                    }
                    label={"Or"}
                  />
                  <FormControlLabel
                    control={
                      <Radio
                        color="primary"
                        checked={!checked}
                        onChange={() => handleChange(false)}
                      />
                    }
                    label={"And"}
                  />
                </RadioGroup>
              </Tooltip>
            </Grid>
          );
        },	
    };
  }

  const handleChange = (checked) => {
    let tableState = JSON.parse(localStorage.getItem("MeteringPointsSettings") || "{}");
    localStorage.setItem(
      "MeteringPointsSettings",
      JSON.stringify({
        page: tableState.page,
        rowsPerPage: tableState.rowsPerPage,
        filterList: tableState.filterList,
        sortOrder: tableState.sortOrder,
        columns: tableState.columns,
        orfilter: checked
      })
    ); 
    setCheked(checked);       
  };

  function getColumns(savedSettings) {
    const sortDirection = (saveSettings) => 
      savedSettings.sortOrder && savedSettings.sortOrder.name === 'metering_point_id' ? savedSettings.sortOrder.direction : 'none'
    let columns = [
      {
        name: "metering_point_id",
        label: intl.formatMessage({ id: "metering_point.metering_point_id" }),
        options: {
          filter: false,
          sort: true,
          sortDirection: sortDirection('metering_point_id'),
          display: (savedSettings.columns && savedSettings.columns.length > 0) ? savedSettings.columns[0].display === 'true' : true
        },
      },
      {
        name: "address",
        label: intl.formatMessage({ id: "metering_point.address" }),
        options: {
          filter: false,
          sort: true,
          sortDirection: sortDirection('address'),
          display: (savedSettings.columns && savedSettings.columns.length > 0) ? savedSettings.columns[1].display === 'true' : true
        },
      },
      {
        name: "ref-period",
        label: intl.formatMessage({ id: "metering_point.ref_period" }),
        options: {
          filter: false,
          sort: false,
          display: (savedSettings.columns && savedSettings.columns.length > 0) ? savedSettings.columns[2].display === 'true' : true
        },
      },
      {
        name: "status",
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          sortDirection: sortDirection('status'),
          display: (savedSettings.columns && savedSettings.columns.length > 0) ? savedSettings.columns[3].display === 'true' : true
        },
      }, 
      {
        name: "prio",
        label: 'Prio',
        options: {
          filter: true,
          sort: true,
          sortDirection: sortDirection('prio'),
          display: (savedSettings.columns && savedSettings.columns.length > 0) ? savedSettings.columns[4].display === 'true' : false
        },
      },
      {
        name: "note",
        label: 'Senaste kommentar',
        options: {
          filter: false,
          sort: true,
          sortDirection: sortDirection('note'),
          display: (savedSettings.columns && savedSettings.columns.length > 0) ? savedSettings.columns[5].display === 'true' : false
        },
      },            
      {
        name: "tags",
        label: intl.formatMessage({ id: "metering_point.tags" }),
        options: {
          filter: true,
          sort: false,
          display: (savedSettings.columns && savedSettings.columns.length > 0) ? savedSettings.columns[6].display === 'true' : true, 
          filterOptions: checked
            ? {
                logic(tags, filters) {
                  let show = false;
                  tags.forEach((tag) => {
                    if (filters.indexOf(tag) >= 0) {
                      show = true;
                    }
                  });
                  return !show;
                },
              }
            : {},
          customBodyRender: (value, tableMeta, updateValue) => {
            return <ListOfChips tags={value} />;
          },
        },
      },
      {
        name: "labels",
        label: intl.formatMessage({ id: "metering_point.labels" }),
        options: {
          filter: true,
          sort: true,
          sortDirection: sortDirection('labels'),
          display: (savedSettings.columns && savedSettings.columns.length > 0) ? savedSettings.columns[7].display === 'true' : false
        },
      },
      {
        name: "deviations",
        label: intl.formatMessage({ id: "metering_point.deviations" }),
        options: {
          filter: true,
          sort: true,
          sortDirection: sortDirection('deviations'),
          display: (savedSettings.columns && savedSettings.columns.length > 0) ? savedSettings.columns[8].display === 'true' : false
        },
      },    
    ];

    columns = columns.map((column, index) => ({
      ...column,
      options: {
        ...column.options,
        filterList:
          savedSettings.filterList?.[index] ?? []
      }
    }));
    return columns;
  }

  useEffect(() => {
    localforage.getItem('meteringPoints').then((value) => {
      if (value === null) {
        fetchAllMeteringPoints();
      } else {
        updateTable(value);
        fetchAllMeteringPoints();
      }
    }).catch(() => {
      console.log("Error reading from localforage");
      fetchAllMeteringPoints();
    })
  }, []);

  function updateTable(listOfMeteringPoints) {
    let list = [];
    listOfMeteringPoints.forEach((meteringPoint) => {
      try {
        
        let address = "";
        if ("location" in meteringPoint) {
          try {
            address = meteringPoint.location.address.street_address + " " + meteringPoint.location.address.city;
          } catch (err) {}
        }
        let refPeriod = "";
        let tags = [];
        if ("tags" in meteringPoint) {
          meteringPoint.tags.forEach((tag) => {
            let key = tag.key;
            tag.val.forEach((value) => {
              tags.push(key + ":" + value);
            });
          });
        }
        if (("reference_from" in meteringPoint) && ("reference_to" in meteringPoint)) {
          refPeriod = meteringPoint.reference_from + " - " + meteringPoint.reference_to;
        } else {
          // refPeriod = "[" + "missing" + "]"
          refPeriod = intl.formatMessage({
            id: "metering_points.missing_reference_period" })
        }
        let prio = "";
        if ("prio" in meteringPoint) {
          prio = meteringPoint.prio;
        }

        let note = "";
        if ("notes" in meteringPoint) {
          const manualNotes = meteringPoint.notes.filter((note) => note.user !== 'k2' && note.user !== 'house keeping service');
          if (manualNotes.length > 0) {
            note = manualNotes[manualNotes.length - 1]['text'];
          }
        }

        // parse labels and build indexing info for hidden collumn
        //
        let labels = [];
        if ("labels" in meteringPoint) {
          meteringPoint.labels.forEach((label) => {
/** Uncomment to enable description freetext search 
            var words = label.description.split(' ');
            words.forEach((word) => {
              labels.push(word);
            });
*/
            label.tags.forEach((tag) => {
              let key = tag.key;
              tag.val.forEach((value) => {
                labels.push(key + ":" + value);
              });
            });
  
          });
        }

        // parse protocols/deviations and build indexing info for hidden collumn
        //
        let deviations = []
        if ("protocols" in meteringPoint) {
          meteringPoint.protocols.forEach((protocol) => {
            deviations.push(protocol.creator)
            for (let key in protocol.deviations) {
            //protocol.deviations.forEach((deviation) => {
                let deviation = protocol.deviations[key];

                let action = deviation.action; //translate code
                let cause = deviation.cause;  //translate code
                let component = deviation.component; //translate code
                let energy_usage_change = deviation.energy_usage_change; //translate code
                let status = deviation.status; //translate code

                let actionStr = intl.formatMessage({id: "metering_point.create_protocol_action_" + action });
                let causeStr = intl.formatMessage({id: "metering_point.create_protocol_deviation_cause_" + cause });
                let componentStr = intl.formatMessage({id: "metering_point.create_protocol_" + component });
                let statusStr = intl.formatMessage({id: "metering_point.create_protocol_" + status });
                let energy_usage_changeStr = "";
                if (energy_usage_change.length>0) {
                  intl.formatMessage({id: "metering_point.create_protocol_energy_usage_change_" + energy_usage_change });
                }
/**             Uncomment to enable freetext search
                let action_other_str = deviation.action_other; //freetext 
                let component_other_str = deviation.component_other; //freetext
                let fault_description_str = deviation.fault_description; //freetext
                let pushvalues = [actionStr, causeStr, componentStr, statusStr, energy_usage_changeStr];
                let pushvalues = [action_other_str, component_other_str, fault_description_str, actionStr, causeStr, componentStr, statusStr, energy_usage_changeStr];
                for (let val in pushvalues) {
                  val = pushvalues[val];
                  if (val.length>0) {
                    deviations.push(val)
                  }
                }
*/
              }
  
            });
  
        }
        const tx_key = "metering_points.status_" + (meteringPoint.status ? meteringPoint.status[0] : '');
        let tx_status = '';
        if (tx_key !== "metering_points.status_") {
          tx_status = intl.formatMessage({id: tx_key});
        }
        list.push([meteringPoint.metering_point_id, address, refPeriod, tx_status, prio, note, tags, labels, deviations]);
      } catch (err) {
        console.log(err);
      }
    });
    setMeteringPoints(list);
  }

  function fetchMeteringPoints(token, lastUpdated) {
    var headers = { Authorization: "Bearer " + token };
    var params = { limit: 9999999999, updated_since: lastUpdated };
    return axios.get(context.config.meteringPointsAPI + "/", { headers, params });
  }

  async function fetchAllMeteringPoints() {
    const lastUpdated = (await localforage.getItem('meteringPointsLastUpdated')) || "1970-01-01T00:00:00Z";
    const fetchTime = new Date().toISOString();

    context.keycloak
      .updateToken(5)
      .success(function () {
        axios
          .all([fetchMeteringPoints(context.keycloak.token, lastUpdated)])
          .then(
            axios.spread(async function (meteringPointResponse) {
              const incoming = meteringPointResponse.data;
              const cached = (await localforage.getItem('meteringPoints')) || [];

              const map = new Map(cached.map(mp => [mp.metering_point_id, mp]));
              incoming.forEach(mp => map.set(mp.metering_point_id, mp));
              const merged = Array.from(map.values());

              await localforage.setItem('meteringPoints', merged);
              await localforage.setItem('meteringPointsLastUpdated', fetchTime);
              updateTable(merged);
            })
          )
          .catch((error) => {
            console.log(error);
          });
      })
      .error(function () {
        context.keycloak.login();
      });
  }

  return (
    <React.Fragment>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Typography variant="h5" color="textSecondary">
            <FormattedMessage id="metering_points.metering_points" />
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Paper>
            <div>
                {uploadButton()}
            </div>
            <MUIDataTable data={meteringPoints} columns={columns} options={options} />
          </Paper>
        </Grid>
      </Grid>
      <MeteringPointProtocolUploadDialog
                showProtocolUploadDialog = {showProtocolUploadDialog}
                toggleProtocolUploadDialog = {toggleProtocolUploadDialog}
                fetchAllMeteringPoints = {fetchAllMeteringPoints}
            />
    </React.Fragment>
  );
}
